/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";
// core components
import smallBanner from "assets/img/headerSmaller.jpg"
import smallestBanner from "assets/img/headerSmallest.jpg"
import Carousel from "views/index-sections/Carousel.js"

function IndexHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <Carousel/>
      <div className="page-header clear-filter" filter-color="blue">
       <div
          className="page-header-image" 
          style={{
            backgroundImage: "",
          }}
          ref={pageHeader}
        ></div>
      </div>
    </>
  );
}

export default IndexHeader;
